import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AmorphicService } from '../../../../services/amorphic/amorphic.service';
import { ModalService } from '../../../../services/modal/modal.service';
import { ApplicationService } from '../../../../services/application/application.service';
import { BaseModalComponent } from '../../base-modal.component';
import { UnsupportedCase } from '../../../../classes/UnsupportedUseCases';
import { ModalType } from '../../../../../js/interfaces/CoverpathTypes';
import { UnsupportedUseCasesService } from '../../../../services/unsupportedUseCases/unsupportedUseCases.service';
import { ReplacementThankYouModalConfig } from '../generic/generic.configs';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  moduleId: module.id,
  selector: 'replacement',
  templateUrl: './replacement.component.html',
})
export class ReplacementComponent extends BaseModalComponent implements OnInit {
  modalText: Array<string>;
  propName: string;
  showSecondQuesion: boolean = false;
  isAdvisor: boolean = false;
  internalPolicies: string;

  selectOptions = [
    { value: 'Term Life', description: 'Term Life' },
    { value: 'Whole Life', description: 'Whole Life' },
    { value: 'Other', description: 'Other' },
  ];

  selectValues = ['Term Life', 'Whole Life', 'Other'];

  YesNoOptions = [
    { value: 'Yes', description: 'Yes' },
    { value: 'No', description: 'No' },
  ];

  public replaceForm: FormGroup;
  private replaceProp: string = 'customer.application.primaryPolicy.insured.existingPolicies.replaceInforceApplication';

  constructor(
    private amorphicService: AmorphicService,
    private appService: ApplicationService,
    private router: Router,
    private formBuilder: FormBuilder,
    private unsupportedUseCasesService: UnsupportedUseCasesService,
    modalService: ModalService
  ) {
    super(modalService);
    this.replaceForm = this.formBuilder.group({
      policyType: undefined,
      YesNoProperty: undefined,
    });
  }

  ngOnInit() {
    this.isAdvisor = this.appService.appState.isAdvisor;
    this.internalPolicies = 'Northwestern Mutual';
  }

  public setPropName(val: string) {
    this.propName = val;
  }

  public getSelectedPolicyOption(): void {
    const value = this.replaceForm.get('policyType').value;

    this.getSelected(value);
  }

  public getSelected(value: string): void {
    this.appService.submitValueAndFireTriggers(this.replaceProp, undefined);
    switch (value) {
      case 'Whole Life':
        this.showSecondQuesion = true;
        break;
      case 'Other':
        this.unsupportedUseCasesService.activateUnsupportedUseCasesModal(UnsupportedCase.replaceOther);
        break;
      case 'Term Life':
        this.showSecondQuesion = true;
        break;
      default:
        break;
    }
  }

  public setValue() {
    const value = this.replaceForm.get('YesNoProperty').value;
    this.setRadio(value);
  }

  public setRadio(value: string): void {
    if (value === 'Yes') {
      this.unsupportedUseCasesService.activateUnsupportedUseCasesModal(UnsupportedCase.replaceNorthwesternMutual);
      this.appService.submitValueAndFireTriggers(this.replaceProp, undefined);
    } else {
      this.showThankYou();
      this.appService.submitValueAndFireTriggers(this.replaceProp, true);
    }
  }

  cancel() {
    this.appService.submitValueAndFireTriggers(this.replaceProp, undefined);
  }

  confirm() {}

  goBack() {
    this.modalService.deactivate();
    this.appService.submitValueAndFireTriggers(this.replaceProp, undefined);
  }

  exit() {
    if (this.appService.appState.isAdvisor) {
      this.router.navigate(['home']);
    }
  }

  private showThankYou(): void {
    const modalType = {
      type: ModalType.policyReplacementThankYou,
    };
    this.appService.submitValueAndFireTriggers(this.replaceProp, true);
    this.modalService.activate(ReplacementThankYouModalConfig);
  }

  public preDeactivate(): void {
    this.appService.submitValueAndFireTriggers(this.replaceProp, undefined);
  }
}
